module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_elite.1f672672.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_elite.png
// module id = 3470
// module chunks = 11